import { Component, NgModule, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { UserPanelModule } from '../../user-panel/user-panel.component';
import { ApiService } from '../../../services/api.service';
import { DxButtonGroupModule, DxCheckBoxModule, DxFormComponent, DxFormModule, DxMapModule, DxPopupModule, DxScrollViewModule, DxTextAreaModule, DxValidatorModule } from 'devextreme-angular';
import { BrowserModule } from '@angular/platform-browser';
import { AuthService } from '../../../services';
import { IPPP, PPPPrijedlog } from 'src/app/shared/models/ppp.model';
import notify from 'devextreme/ui/notify';
import { GooglePlaceDirective, GooglePlaceModule } from 'ngx-google-places-autocomplete';

@Component({
  selector: 'add-prijedlog-form',
  templateUrl: 'add-prijedlog-form.component.html',
  styleUrls: ['./add-prijedlog-form.component.scss']
})

export class AddPrijedlogFormComponent implements OnInit {
  @ViewChild("addPrijedlogForm", { static: false }) addPrijedlogForm: DxFormComponent;
  mapMarkers = [];
  keys={};

  @ViewChild("placesRef") placesRef : GooglePlaceDirective;

  @Input()
  isPopupVisible: boolean = false;
  @Input()
  partnerId!: number;
  
  @Output() openModalChange = new EventEmitter<boolean>();
  @Output() prijedlogCreated = new EventEmitter<boolean>();
  
  prijedlog: IPPP;

  constructor(
    private _api: ApiService,
    private _authService: AuthService,
  ) {
  }

  ngOnInit(): void {
    this.initPrijedlogValues();
  }

  initPrijedlogValues(){
    this.prijedlog = new PPPPrijedlog();
  }

  refresh() {
    this.addPrijedlogForm.instance.resetValues();
  }

  closePopup(): void {
    this.refresh();
    this.initPrijedlogValues();
    this.openModalChange.emit(false);
  }

  openPopup(): void {
    this.openModalChange.emit(true);
  }

  form_fieldDataChanged (e) {
    let updatedField = e.dataField;
    let newValue = e.value;
  }

  onFormSubmit(e: any){
    e.preventDefault();
    this.submitForm();
  }

  submitForm(){
    this.dodajPrijedlog();
  }

  onShown(e){
    this.addPrijedlogForm.instance.getEditor("pr_naziv").focus();
  }

  dodajPrijedlog(){
    const request = this.buildRequestFormData();
    this._api.dodaj3P(request).subscribe(res=>{
      if(res.success == true){
        notify("Uspješno ste dodali prijedlog!", "success", 1000);
        this.closePopup();
        this.prijedlogCreated.emit(true);
      } else {
        notify("Greška prilikom dodavanja prijedloga!", "error", 1000);
      }
    });
  }

  buildRequestFormData(){
    let formData:FormData = new FormData();
    formData.append('naziv', this.prijedlog.pr_naziv);
    formData.append('opis', this.prijedlog.pr_opis);
    formData.append('adresa', this.prijedlog.pr_adresa);
    formData.append('vrsta', this.prijedlog.pr_vrsta.toString());
    formData.append('lat', '1');
    formData.append('lon', '1');
    formData.append('idproblem', '4');
    formData.append('idgost', null);
    formData.append('idpartner', this._authService.getUserPartnerId().toString());
    formData.append('datoteka', null);
    formData.append('access_token', this._authService.getToken().toString());
    return formData;
  }

}

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    DxButtonModule,
    UserPanelModule,
    DxToolbarModule,
    DxPopupModule,
    DxFormModule,
    DxScrollViewModule,
    DxButtonGroupModule,
    DxCheckBoxModule,
    DxValidatorModule,
    DxTextAreaModule,
    DxMapModule,
    GooglePlaceModule
  ],
  declarations: [ AddPrijedlogFormComponent ],
  exports: [ AddPrijedlogFormComponent ]
})
export class AddPrijedlogFormComponentModule { }
